import { useMemo } from 'react';
import { useRouter } from 'next/router';

import ALink from '~/components/features/custom-link';
import { useStoreCategories } from '~/hooks/useStoreCategories';

// Categorías "ricas" (con muchas subcategorías) para el submenú Descubre.
const MIN_SUBCATEGORIES = 5;
const DISCOVER_COLUMNS = 2;

// Nav central del sub-nav (tienda de canje). "Descubre" abre un megamenu con
// accesos rápidos (lo que alcanza con sus puntos / aleatorio) + 2 columnas de
// categorías aleatorias (con >5 subcategorías) mostrando sus subcategorías.
function MainMenu() {
  const { pathname, query } = useRouter();
  const onShop = pathname.includes('/shop');
  const { data = [] } = useStoreCategories();

  // 2 categorías aleatorias con más de 5 subcategorías (memoizadas).
  const discoverCategories = useMemo(() => {
    const eligible = data.filter((category) => category.children.length > MIN_SUBCATEGORIES);
    for (let i = eligible.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [eligible[i], eligible[j]] = [eligible[j], eligible[i]];
    }
    return eligible.slice(0, DISCOVER_COLUMNS);
  }, [data]);

  const onDiscover = onShop && (!!query.random || !!query.buyable);

  return (
    <nav className="main-nav">
      <ul className="menu menu-active-underline">
        <li className={pathname === '/' ? 'active' : ''}>
          <ALink href="/">Inicio</ALink>
        </li>

        <li className={onShop && !query.random && !query.buyable ? 'active' : ''}>
          <ALink href="/shop">Toda la tienda</ALink>
        </li>

        <li className={`submenu ${onDiscover ? 'active' : ''}`}>
          <ALink href={{ pathname: '/shop', query: { random: true } }}>Descubre</ALink>

          <div className="megamenu">
            <div className="row">
              {/* Accesos rápidos */}
              <div className="col-lg-4 col-6">
                <h4 className="menu-title">
                  <ALink href={{ pathname: '/shop', query: { random: true } }} scroll={false}>
                    Descubre
                  </ALink>
                </h4>
                <hr className="divider" />
                <ul>
                  <li>
                    <ALink href={{ pathname: '/shop', query: { buyable: true } }} scroll={false}>
                      Lo que me alcanza
                    </ALink>
                  </li>
                  <li>
                    <ALink href={{ pathname: '/shop', query: { random: true } }} scroll={false}>
                      Aleatorio
                    </ALink>
                  </li>
                </ul>
              </div>

              {/* 2 columnas de categorías aleatorias con sus subcategorías */}
              {discoverCategories.map((category) => (
                <div className="col-lg-4 col-6" key={category.id}>
                  <h4 className="menu-title">
                    <ALink
                      href={{
                        pathname: '/shop',
                        query: { category: category.id },
                      }}
                      scroll={false}
                    >
                      {category.name}
                    </ALink>
                  </h4>
                  <hr className="divider" />
                  <ul>
                    {category.children.map((subcategory) => (
                      <li key={subcategory.id}>
                        <ALink
                          href={{
                            pathname: '/shop',
                            query: { subcategory: subcategory.id },
                          }}
                          scroll={false}
                        >
                          {subcategory.name}
                        </ALink>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </li>
      </ul>
    </nav>
  );
}

export default MainMenu;
